import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { NotificationService } from './notification.service';

/**
 * Interface pour les messages (compatible avec PrimeNG Message)
 */
interface ToastMessage {
  severity?: string;
  summary?: string;
  detail?: string;
  life?: number;
  sticky?: boolean;
  closable?: boolean;
  key?: string;
  data?: any;
}

/**
 * Service qui étend MessageService de PrimeNG pour capturer automatiquement
 * tous les messages toast et les enregistrer dans l'historique des notifications
 */
@Injectable({
  providedIn: 'root'
})
export class NotificationMessageService extends MessageService {
  constructor(private notificationService: NotificationService) {
    super();
  }

  /**
   * Surcharge de la méthode add pour intercepter les messages
   */
  override add(message: ToastMessage): void {
    // Appeler la méthode originale de MessageService pour afficher le toast
    super.add(message);

    // Enregistrer dans l'historique des notifications
    if (message.severity && message.summary) {
      // Map les sévérités PrimeNG vers notre type
      const severity = this.mapSeverity(message.severity);
      const summary = message.summary || 'Notification';
      const detail = message.detail || '';

      this.notificationService.addNotification(
        severity,
        summary,
        detail
      );
    }
  }

  /**
   * Surcharge de la méthode addAll pour intercepter plusieurs messages
   */
  override addAll(messages: ToastMessage[]): void {
    // Appeler la méthode originale
    super.addAll(messages);

    // Enregistrer chaque message dans l'historique
    messages.forEach(message => {
      if (message.severity && message.summary) {
        const severity = this.mapSeverity(message.severity);
        const summary = message.summary || 'Notification';
        const detail = message.detail || '';

        this.notificationService.addNotification(
          severity,
          summary,
          detail
        );
      }
    });
  }

  /**
   * Mapper les sévérités PrimeNG vers notre type
   */
  private mapSeverity(severity: string): 'success' | 'info' | 'warn' | 'error' {
    const mapping: { [key: string]: 'success' | 'info' | 'warn' | 'error' } = {
      'success': 'success',
      'info': 'info',
      'warn': 'warn',
      'warning': 'warn',
      'error': 'error',
      'danger': 'error'
    };

    return mapping[severity.toLowerCase()] || 'info';
  }
}
